import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import Badges from '../Badges/Badges';
import Menu from '../Menu/Menu';
import H from '../H/H';
import Icon from '../Icon/Icon';

export default class BaseRenderer extends PureComponent {

  static displayName = 'BaseRenderer';

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    description: PropTypes.node,
    error: PropTypes.string,
    folder: PropTypes.bool,
    footer: PropTypes.node,
    icons: PropTypes.node,
    item: PropTypes.object,
    level: PropTypes.number,
    locked: PropTypes.bool,
    onCreateMenuItems: PropTypes.func,
    onCloseMenu: PropTypes.func,
    tag: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.node,
    warning: PropTypes.string,
  };

  render() {
    const { children, className, description, error, folder, icons, iconName, imageUrl, item, level, locked, onCreateMenuItems,
      onCloseMenu, tag, tags, title, type, warning, ...rest } = this.props;
    let footer;
    let thumb;
    let state;
    let tools;

    if (this.props.footer || tag || (tags && tags.length)) {
      footer = (
        <span className="footer-wrapper">
          {(tag || tags) && <Badges label={tag} labels={tags}/>}
          {this.props.footer && <span className="footer">{this.props.footer}</span>}
        </span>
      );
    }
    if (children) {
      thumb = (
        <div className="thumb">
          {children}
        </div>
      );
    } else if (folder) {
      thumb = <Icon className={cx('base-renderer-folder', { 'top-aligned': description || footer || tag})} name="folder"/>;
    }
    if (error) {
      state = <Icon className="error" name="error" title={error}/>;
    } else if (warning) {
      state = <Icon className="warning" name="warning" title={warning}/>;
    }
    if (onCreateMenuItems || state || icons) {
      tools = (
        <div className="badges">
          {icons}
          {state}
          {onCreateMenuItems && <Menu className="cell-menu" data={item} onCreateMenuItems={onCreateMenuItems} onClose={onCloseMenu}/>}
        </div>
      );
    }
    return (
      <div className={cx('core-base-renderer', className)} {...rest}>
        {thumb}
        <div className={cx('info', { menu: onCreateMenuItems })}>
          <H level={level}>{title}</H>
          {description && <span className="description">{description}</span>}
          {footer}
          {(description || footer) && tools}
        </div>
        {!footer && !description && tools}
      </div>
    );
  }

}
